import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute } from "@angular/router";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import LocalizationConstants from "src/app/constants/localization-constants";
import RouteNameConstants from "src/app/constants/route-name-constants";
import { Column } from "src/app/models/Column";
import { ContractToolFilter } from "src/app/models/ContractToolFilter";
import { QuoteReport } from "src/app/models/Enums";
import { ExcelExportType } from "src/app/models/ExcelExport";
import { CompanyService } from "src/app/services/company.service";

import { ContractTool } from "../../models/ContractTool";
import { ContractService } from "./../../services/contract.service";

@Component({
  selector: "app-contract-tools",
  templateUrl: "./contract-tools.component.html",
  styleUrls: ["./contract-tools.component.scss"],
  standalone: false,
})
export class ContractToolsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  readonly localizationConstants = LocalizationConstants;
  readonly routeNameConstants = RouteNameConstants;
  dataSource = new MatTableDataSource<ContractTool>([]);
  isLoading: boolean;
  faSpinner = faSpinner;
  contractRef: string;
  pageSize: number = 10;
  ExcelExportType = ExcelExportType;
  columns: Column[] = [];

  columnKeys: string[] = [];

  filter: ContractToolFilter;

  constructor(
    public contractService: ContractService,
    private companyService: CompanyService,
    private route: ActivatedRoute,
  ) {
    this.columns = this.contractService.getContractToolsColumns();
    this.columnKeys = this.columns.map((column) => column.key);
  }

  ngOnInit() {
    this.contractRef = this.route.parent.snapshot.paramMap.get("contractReference");

    this.filter = this.getContractToolsFilter();

    if (!this.companyService.selectedCompany?.name) return;
    this.getContractTools();
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  getContractTools() {
    this.isLoading = true;
    this.contractService
      .getContractTools(this.companyService.selectedCompany.name, this.contractRef)
      .subscribe(
        (response) => {
          this.isLoading = false;
          if (!response) return;
          this.dataSource.data = response;
        },
        () => (this.isLoading = false),
      );
  }

  private getContractToolsFilter(): ContractToolFilter {
    const filter = new ContractToolFilter();
    filter.companyId = this.companyService.selectedCompany.name;
    filter.asc = false;
    filter.report = QuoteReport.ContractTools;
    filter.contractId = this.contractRef;
    return filter;
  }
}
